module.exports = __webpack_public_path__ + "static/mobile-map-a974f471de0529f4fbc25f847dea94d1.webp";